import { render, staticRenderFns } from "./Placeholder.vue?vue&type=template&id=1bdb6215&scoped=true"
var script = {}
import style0 from "./Placeholder.vue?vue&type=style&index=0&id=1bdb6215&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdb6215",
  null
  
)

export default component.exports